import React, { useEffect, useState, useMemo, useCallback } from "react";
import { FaLocationArrow } from "react-icons/fa";
import "../styles/Hero.css";

const GRID_SQUARE_COUNT = 400;

function Hero() {
  const [showSubtitle, setShowSubtitle] = useState(false);
  const [showTitle, setShowTitle] = useState(false);
  const [showDescription, setShowDescription] = useState(false);
  const [showButtons, setShowButtons] = useState(false);

  const animateSquares = useCallback(() => {
    const squares = document.querySelectorAll(".grid-square");
    squares.forEach(square => square.classList.remove("active"));
    const randomSquares = Array.from({ length: 20 }, () =>
      Math.floor(Math.random() * squares.length)
    );
    randomSquares.forEach(i => {
      squares[i]?.classList.add("active");
    });
  }, []);

  useEffect(() => {
    const interval = setInterval(animateSquares, 5000);

    const timeouts = [
      setTimeout(() => setShowTitle(true), 300),
      setTimeout(() => setShowSubtitle(true), 500),
      setTimeout(() => setShowDescription(true), 700),
      setTimeout(() => setShowButtons(true), 900),
    ];

    return () => {
      clearInterval(interval);
      timeouts.forEach(clearTimeout);
    };
  }, [animateSquares]);

  const gridSquares = useMemo(
    () =>
      Array.from({ length: GRID_SQUARE_COUNT }, (_, index) => (
        <div key={index} className="grid-square" />
      )),
    []
  );

  return (
    <section className="hero" id="hero">
      <div className="light-overlay"></div>
   
      <div className="hero-content">
        <p className={`subtitle ${showSubtitle ? "show" : ""}`}>
          CAPTIVATING WEB EXPERIENCES POWERED BY THE LATEST MODERN TECH

        </p>

        <h1 className={`title ${showTitle ? "show" : ""}`}>
          First impressions last <br className="responsive-br" /> so <span className="highlight">make it count</span>
        </h1>

        <p className={`description ${showDescription ? "show" : ""}`}>
          Hi! I'm Reham Magharee , a Front-End Developer with React & Next.js
        </p>

       <div className={`buttons ${showButtons ? "show" : ""}`}>
  <a
  href="/cv.pdf"
  download
  className="btn fancy-border"
>
  Download CV <FaLocationArrow size={13} />
</a>

  <a
    href="https://github.com/RehamRaed"
    target="_blank"
    rel="noopener noreferrer"
    className="btn fancy-border"
  >
    Show my work <FaLocationArrow size={13} />
  </a>
</div>
      </div>

      <div className="grid-overlay">
        {gridSquares}
      </div>
    </section>
  );
}

export default Hero;
